import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { filter, firstValueFrom } from 'rxjs';

import { SecurityService } from '@connect-services/client/services/security.service';

export async function isDoticAdminGuard(): Promise<boolean> {
    const securityService = inject(SecurityService);
    const router = inject(Router);

    await firstValueFrom(toObservable(securityService.initialized).pipe(filter(Boolean)));

    if (securityService.isAuthenticated() && securityService.meSignal()?.role?.isAdmin) {
        return true;
    }

    return router.navigate(['/']);
}
